import React, { Component, Fragment } from 'react';

class AniBox extends Component {
    render() {
        return (
            <Fragment>
                <div className="cl1"></div>
                <div className="cl2"></div>
                <div className="delivery"></div>
                <div className="chat">배달 접수</div>
                <div className="streetlight"></div>
            </Fragment>
        );
    }
}

export default AniBox;